// useEscClose — zavření detailu/dialogu klávesou Esc (16.7.2026).
//
// Globální stack: Esc zavře vždy jen NEJVRCHNĚJŠÍ otevřený detail (naposledy
// namountovaný), takže vnořené dialogy (např. potvrzení uvnitř detailu osoby)
// se zavírají postupně — jeden Esc = jedna vrstva.
//
// Esc stisknutý v input/textarea/select/contentEditable se ignoruje — tam si
// ho řeší pole samo (zrušení rozepsané editace), nemá zavřít celý detail.
import { useEffect, useRef } from "react";

const stack = [];

function onKey(e) {
  if (e.key !== "Escape") return;
  const t = e.target;
  const tag = t && t.tagName ? t.tagName.toUpperCase() : "";
  if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || (t && t.isContentEditable)) return;
  const top = stack[stack.length - 1];
  if (top && typeof top.cb === "function") {
    e.preventDefault();
    e.stopPropagation();
    top.cb();
  }
}

export default function useEscClose(onClose, active = true) {
  // cb v ref: entry zůstává stabilní po celou dobu mountu (pořadí ve stacku
  // = pořadí otevření), ale volá se vždy aktuální onClose.
  const cbRef = useRef(onClose);
  cbRef.current = onClose;
  useEffect(() => {
    if (!active) return undefined;
    const entry = { get cb() { return cbRef.current; } };
    stack.push(entry);
    if (stack.length === 1) window.addEventListener("keydown", onKey, true);
    return () => {
      const i = stack.indexOf(entry);
      if (i >= 0) stack.splice(i, 1);
      if (stack.length === 0) window.removeEventListener("keydown", onKey, true);
    };
  }, [active]);
}
